<!-- eslint-disable vue/html-self-closing -->
<template>
  <div class="row custom-options-checkable g-1">
    <div class="col-md-6">
      <input
        :id="'level-1-' + parameter.id"
        :name="'level-' + parameter.id"
        class="custom-option-item-check"
        type="radio"
        :disabled="!convo.open_applicants"
        :value="'Yes'"
        :checked="answer ? answer.value == 'Yes' : false"
        @change="submitAnswer($event)"
      />
      <label
        class="custom-option-item p-1"
        :for="'level-1-' + parameter.id"
      >
        <span class="d-flex justify-content-between flex-wrap mb-50">
          <span class="fw-bolder">
            Yes
          </span>
        </span>
      </label>
    </div>
    <div class="col-md-6">
      <input
        :id="'level-2-' + parameter.id"
        :name="'level-' + parameter.id"
        class="custom-option-item-check"
        type="radio"
        :disabled="!convo.open_applicants"
        :value="'No'"
        :checked="answer ? answer.value == 'No' : false"
        @change="submitAnswer($event)"
      />
      <label
        class="custom-option-item p-1"
        :for="'level-2-' + parameter.id"
      >
        <span class="d-flex justify-content-between flex-wrap mb-50">
          <span class="fw-bolder">
            No
          </span>
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {},
  props: {
    answer: {},
    parameter: { type: Object, required: true },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      convo: 'convo/convo',
    }),
  },
  methods: {
    submitAnswer(event) {
      this.$emit('submitAnswer', event.target.value)
    },
  },
}
</script>
